import { footer } from './pt/footer';
import { navigation } from './pt/navigation';
import { easterCamp, christmasCamp, summerCamp, summerCampConfirmation } from './pt/camps';
import { prices } from './pt/prices';
import { montessori } from './pt/montessori';
import { openHouse } from './pt/openHouse';
import { extracurriculars } from './pt/extracurriculars';
import { feedback } from "./pt/feedback";
import { courses } from "./pt/courses";
import { schoolCalendar } from './pt/schoolCalendar';
import { birthdays } from './pt/birthdays';
import { services } from './pt/services';
import { admissions } from './pt/admissions';
import { enrollmentForm } from './pt/enrollmentForm';
import { enrollmentConfirmation } from './pt/enrollmentConfirmation';
import { hero } from './pt/hero';
import { trustBadges } from './pt/trustBadges';
import { valueProposition } from './pt/valueProposition';
import { testimonials } from './pt/testimonials';
import { ctaSection } from './pt/ctaSection';
import { gallery } from './pt/gallery';
import { activities } from './pt/activities';
import { principles } from './pt/principles';
import { howWeTeach } from './pt/howWeTeach';
import { trilingualModel } from './pt/trilingualModel';
import { neasc } from './pt/neasc';
import { visitBanner } from './pt/visitBanner';
import { renewalForm } from './pt/renewalForm';
import { renewalConfirmation } from './pt/renewalConfirmation';
import { openHouseRegistration } from './pt/openHouseRegistration';

export const pt = {
  navigation,
  footer,
  hero,
  trustBadges,
  valueProposition,
  howWeTeach,
  trilingualModel,
  neasc,
  gallery,
  activities,
  principles,
  testimonials,
  ctaSection,
  easterCamp,
  christmasCamp,
  summerCamp,
  summerCampConfirmation,
  prices,
  montessori,
  openHouse,
  openHouseRegistration,
  extracurriculars,
  feedback,
  courses,
  schoolCalendar,
  birthdays,
  services,
  admissions,
  enrollmentForm,
  enrollmentConfirmation,
  renewalForm,
  renewalConfirmation,
  visitBanner,
  title: "Gándara International School",
  description: "Gándara International School, educação Montessori em Vigo",
  trilingual: {
    title: "Educação Trilíngue",
    metaDescription: "Nossa abordagem trilíngue na Gándara International School",
    bookVisit: "Agende uma Visita",
    intro: {
      p1: "Na Gándara International School, acreditamos em fornecer uma educação verdadeiramente global que prepare os alunos para o mundo conectado que herdarão.",
      p2: "Nosso programa trilíngue imerge os alunos em espanhol, inglês e Galego, criando oportunidades naturais para a aquisição de idiomas e a compreensão cultural."
    },
    sections: {
      immersion: {
        title: "Imersão Natural em Idiomas",
        p1: "Em vez de ensinar idiomas como disciplinas isoladas, nossa abordagem integra os idiomas ao longo do dia escolar. As crianças experimentam diferentes idiomas em contexto, fazendo conexões e desenvolvendo fluência naturalmente.",
        p2: "Cada idioma tem tempos e espaços dedicados, com professores nativos ou altamente proficientes criando um ambiente linguístico autêntico."
      },
      languages: {
        title: "Três Idiomas, Uma Comunidade",
        p1: "O espanhol serve como nossa língua principal de instrução, conectando os alunos à nossa comunidade local e à cultura espanhola.",
        p2: "O inglês e o Galego são integrados em todo o currículo, com disciplinas e atividades específicas conduzidas em cada idioma para garantir exposição e prática equilibradas."
      },
      benefits: {
        title: "A Vantagem Multilíngue",
        intro: "A pesquisa mostra consistentemente que crianças que aprendem vários idiomas desde cedo desenvolvem vantagens cognitivas significativas:",
        list: [
          "Aprimoramento das habilidades de resolução de problemas e pensamento criativo",
          "Melhor memória e processamento de informações",
          "Maior consciência cultural e empatia",
          "Melhor desempenho acadêmico em todas as disciplinas",
          "Maiores oportunidades educacionais e de carreira no futuro"
        ],
        conclusion: "Esses benefícios vão muito além das habilidades linguísticas, apoiando o desenvolvimento holístico e preparando os alunos para o sucesso em uma sociedade cada vez mais global."
      },
      methodology: {
        title: "Nossa Abordagem",
        content: "Nossa metodologia trilíngue é projetada considerando as capacidades naturais de aquisição de linguagem das crianças. Crianças pequenas têm uma capacidade inata de absorver idiomas sem a confusão frequentemente experimentada por adultos. Por meio de experiências imersivas, atividades envolventes e exposição consistente, os alunos desenvolvem habilidades de comunicação confiantes nos três idiomas."
      },
      environment: {
        title: "Um Ambiente de Apoio",
        p1: "Criamos uma atmosfera positiva e encorajadora onde os alunos se sentem seguros praticando novos idiomas sem medo de cometer erros. O aprendizado é ativo, contextual e significativo.",
        p2: "Nossas turmas pequenas garantem que cada criança receba atenção individualizada e amplas oportunidades para praticar a fala e a audição em cada idioma."
      }
    }
  },
  about: {
    title: "Sobre Nós",
    subtitle: "Conheça nossa equipe de acompanhantes dedicados à educação e ao crescimento de cada criança",
    bookVisit: "Agende uma visita",
    story: {
      title: "A Nossa História",
      content: "Gándara nasceu em 2013 do sonho de duas famílias que procuravam uma educação diferente para os seus filhos: um espaço onde o respeito, a natureza e a liberdade fossem os alicerces da aprendizagem. O que começou como uma pequena escola numa propriedade em Gondomar tornou-se uma escola internacional acreditada pela NEASC, com uma equipa de acompanhantes apaixonados e uma comunidade de famílias que partilham a mesma visão."
    },
    mission: {
      title: "A Nossa Missão",
      content: "Acompanhar cada criança no seu desenvolvimento integral, respeitando os seus ritmos e processos naturais, num ambiente de natureza onde a aprendizagem ativa, a convivência multilingue e a curiosidade são o motor de cada dia."
    },
    values: {
      title: "Os Nossos Valores",
      items: [
        { title: "Respeito", description: "Pelos ritmos, emoções e processos únicos de cada criança." },
        { title: "Autonomia", description: "Fomentamos a independência e a confiança nas próprias capacidades." },
        { title: "Comunidade", description: "Famílias, acompanhantes e crianças crescemos juntos num projeto partilhado." },
        { title: "Natureza", description: "Os nossos mais de 5.000 m² de propriedade são uma sala de aula viva para aprender e explorar." },
        { title: "Reinvestimento", description: "A Gándara não distribui lucros: cada euro é reinvestido na escola para oferecer a melhor educação possível." }
      ]
    },
    video: {
      title: "Descubra a nossa escola"
    },
    teamTitle: "Nossa Equipe",
    photoComingSoon: "Foto em breve",
    back: "Voltar",
    team: [
      {
        name: "Patricia Méndez",
        role: "Codiretora",
        description: "Fundei com o Pablo a Barkibu, o projeto que nos permite apoiar a Gándara e onde cuidamos dos animais e das suas famílias. Apaixonámo-nos pela Gándara porque as nossas filhas crescem aqui e acreditamos que é a melhor educação possível: por isso a apoiamos e acompanhamos as famílias no dia a dia."
      },
      {
        name: "Pablo Pazos",
        role: "Codiretor",
        description: "A Patricia e eu somos os fundadores da Barkibu, o projeto que nos permite apoiar a Gándara e onde cuidamos dos animais e das suas famílias. Apaixonámo-nos pela Gándara como família: as nossas filhas estudam aqui e acreditamos que esta é a melhor educação possível. Por isso a apoiamos e a gerimos para que dure muitos anos."
      },
      {
        name: "Iago Ferraz",
        role: "Fundador, diretor pedagógico e acompanhante",
        description: "Durante quinze anos sonhei em criar uma escola diferente: um lugar de convivência baseado no respeito e no amor pelas crianças, em plena natureza. Hoje esse sonho é a Gándara, onde aprendo e desfruto cada dia com os melhores mestres: as próprias crianças. Fazer parte disto deixa-me profundamente agradecido."
      },
      {
        name: "Verónica Álvarez",
        role: "Subdiretora",
        description: "A Gándara é para mim muito mais do que um trabalho: é a minha segunda casa. Faz-me feliz fazer parte desta pequena grande família e aprender todos os dias com os valores que aqui se respiram: solidariedade, liberdade, integridade e criatividade."
      },
      {
        name: "Alba Couse",
        role: "Acompanhante do Infantil",
        description: "Sou professora de Educação Infantil com menção em Audição e Linguagem e frequento o mestrado Montessori 0-6 do International Montessori Institute. Conheci a Gándara ao fazer aqui o meu estágio e fiquei: este ano acompanho o Infantil, com um olhar especial para a alta sensibilidade e o cuidado."
      },
      {
        name: "Carmen Aguilar",
        role: "Acompanhante do Ciclo 1",
        description: "Sou professora de Educação Primária com especialidade em Língua Inglesa. A minha experiência como docente e tutora permitiu-me acompanhar crianças com diferentes ritmos, interesses e necessidades. Continuo a formar-me em metodologias ativas e, especialmente, na metodologia Montessori. Encaro esta nova etapa com muita ilusão e o compromisso de acompanhar cada criança com sensibilidade, respeito e carinho."
      },
      {
        name: "David Torres",
        role: "Acompanhante do Ciclo 2 e responsável de Ciências",
        description: "Sou oceanógrafo e divulgador científico: há mais de dez anos aproximo a ciência de públicos de todas as idades, com formação em ciências Montessori, robótica educativa e gamificação. Encanta-me que o assombro pela natureza seja a porta da aprendizagem, do mar à horta."
      },
      {
        name: "Patricia Iglesias",
        role: "Acompanhante do Infantil e inglês no Ciclo 1",
        description: "Filóloga de formação e educadora de vocação: cheguei à educação pelo amor às línguas e fiquei pelas crianças. Há anos que ensino inglês no Infantil através da brincadeira, com formação em pedagogias ativas, Montessori e educação na natureza, e uma abordagem em que o vínculo emocional vem sempre primeiro."
      },
      {
        name: "Paula Alonso",
        role: "Refeitório e acompanhante do Infantil",
        description: "Sou professora de Educação Infantil e passei toda a minha vida profissional entre a educação respeitosa e a natureza: coordenei durante anos a área de 3-6 de um espaço de educação livre e dirigi um centro de lazer infantil. Na Gándara acompanho o refeitório e o Infantil, onde a mesa também é escola: comer com calma, conversar e cuidarmo-nos."
      },
      {
        name: "Sandra Amigo",
        role: "Acompanhante do Ciclo 2 e especialista de inglês",
        description: "Sou professora especializada em língua estrangeira, trilingue inglês-castelhano-catalão e Forest School Teacher. Coordenei o inglês em escolas com mais de 250 alunos e projetos educativos na universidade, sempre com metodologias ativas e Montessori. O meu motor é construir um mundo melhor através de uma educação que fomente a empatia e o respeito por tudo o que nos rodeia."
      },
      {
        name: "Yoli Paz",
        role: "Limpeza e cuidado dos espaços",
        description: "Cuido para que os espaços da Gándara estejam limpos e acolhedores todos os dias. Um ambiente cuidado também educa."
      }
    ]
  }
};
